<template>
  <element>
    <div label="车辆信息" v-for="(item,idx) in vehicleData" :key="idx">
      <form-build
        :form-data="item"
        :form-columns="vehicleFormColumns"
        class="formTable"
      />
      <panel label="证件图片" class="zhengjianxinxi">
        <photo-browser v-model="item.vehicle__vehicleRegCert" label="车辆登记证"/>
        <photo-browser v-model="item.vehicle__vehicleLicenseURL" label="行驶证"/>
        <photo-browser v-model="item.vehicle__vehicleDriverLicense" label="车辆驾驶员驾驶证"/>


      </panel>

      <panel label="车辆相关图片" class="zhengjianxinxi">
        <photo-browser v-model="item.vehicle__vehicleInsurance1" label="车辆交强险"/>
        <photo-browser v-model="item.vehicle__vehicleInsurance2" label="车辆商业险"/>

        <photo-browser v-model="item.vehicle__vehicleInvoice" label="车辆发票"/>
        <photo-browser v-model="item.vehicle__vehicleOwnershipCert" label="车辆权属证明"/>

        <div class="zhenjianyyzz zhenjianyyzz2" v-if="isShowPic1"><file-upload  v-model="item.vehicle__mortgageCert" :editable="false" ></file-upload>车辆抵押证明</div>

      </panel>
    </div>
  </element>
</template>

<script>
  import Panel from "../../components/Panel";
  import {formatMoney} from "../../filters/CommonFilters";
  import Constant from "../../utils/constant";
  import moment from 'moment';
  export default {
    name: "CustomerVehiclesDetailComponent",
    components: {Panel},
    data() {
      return {
        vehicleFormColumns: [
          {
            label: '车牌号',
            field: 'vehicle__plateNo',
          },
          {
            label: '车辆类型',
            field: 'vehicle__specification',
          },
          {
            label: '车架号',
            field: 'vehicle__vehicleNo',
          },

          {
            label: '发动机号',
            field: 'vehicle__engineNo',
          },
          {
            label: '车辆上牌时间',
            field: 'vehicle__registrationDate',
            formatter: function(r,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            },
          },
         /* {
            label: '期限/年月',
            field: 'vehicle__lifespan',
          },*/
          {
            label: '车辆发票价格',
            field: 'vehicle__buyPrice',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: 'GPS号码',
            field: 'vehicle__GPS',
          },
          {
            label: '测算额度',
            field: 'vehicle__currentValue',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '物流领域',
            field: 'vehicle__bizArea',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },

          /*{
            label: ' 购买价格',
            field: 'vehicle__buyPrice',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },*/
         /* {
            label: '常用运营路线',
            field: 'vehicle__operatingLines',
          },
          {
            label: '违章次数',
            field: 'vehicle__trafficOffence',
          },*/
          {
            label: '里程（12个月）',
            field: 'vehicle__mileage12',
          },
          {
            label: '加油费（12个月）',
            field: 'vehicle__fuelExpense12',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '通行费（12个月）',
            field: 'vehicle__roadToll12',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            },
          },

        ]
      }
    },
    props: {
      value: {
        type: Array,
        default:()=>{
          return []
        }
      },
      isShowPic1: {
        Boolean,
        default: false
      }
    },
    computed: {
      vehicleData: {
        get: function () {
          return this.value.filter(item=>item.vehicle__vehicleId)
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailVehiclesComponent.vue